import { createContext } from 'react'

import defaultProperties from './defaultProperties'

const DialogsContext = createContext(
{
    ...defaultProperties
});

export default DialogsContext ;